import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Col, Row } from 'antd';
import { TextLinkButton } from '../../button';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { styleVariables } from '../../../style';
import { DeviceType, getSize, useDeviceType } from '../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PinStatus;

(function (PinStatus) {
  PinStatus["default"] = "default";
  PinStatus["pinned"] = "pinned";
  PinStatus["unpin"] = "unpin";
})(PinStatus || (PinStatus = {}));

export var getColumnHeightInPinLayout = function getColumnHeightInPinLayout($heightScreen, $pageHeaderHeight) {
  if ($heightScreen) {
    if ($heightScreen.includes('calc(')) {
      return "calc(".concat($heightScreen.replace('calc(', '').replace(')', ''), " - ").concat($pageHeaderHeight, "px)");
    }

    return "calc(".concat($heightScreen, " - ").concat($pageHeaderHeight, "px)");
  }

  return "calc(100vh - ".concat($pageHeaderHeight, "px)");
};
var Layout = styled(Row).withConfig({
  displayName: "pin-layoutcomponent__Layout",
  componentId: "sc-c20uxq-0"
})(["flex:1;min-height:0;background-color:inherit;height:", ";"], function (_ref) {
  var $fillParent = _ref.$fillParent,
      $heightScreen = _ref.$heightScreen,
      $pageHeaderHeight = _ref.$pageHeaderHeight;
  return $fillParent ? '100%' : "calc(".concat(getColumnHeightInPinLayout($heightScreen, $pageHeaderHeight), ")");
});
var StyledCloseButtonWrapper = styled.div.withConfig({
  displayName: "pin-layoutcomponent__StyledCloseButtonWrapper",
  componentId: "sc-c20uxq-1"
})(["position:sticky;top:0;z-index:1;display:flex;justify-content:flex-end;padding:", " ", " 0;background:", ";"], getSize('padding8'), getSize('padding8'), styleVariables.colors.gray1);
var StyledCloseIcon = styled(TextLinkButton).withConfig({
  displayName: "pin-layoutcomponent__StyledCloseIcon",
  componentId: "sc-c20uxq-2"
})(["color:", ";"], styleVariables.colors.grey70);
var StyledSectionQuestionColumn = styled(Col).withConfig({
  displayName: "pin-layoutcomponent__StyledSectionQuestionColumn",
  componentId: "sc-c20uxq-3"
})(["height:100%;min-height:0;overflow-y:auto;&::-webkit-scrollbar{display:none;}"]);
var StyledPinColWrapper = styled(Col).withConfig({
  displayName: "pin-layoutcomponent__StyledPinColWrapper",
  componentId: "sc-c20uxq-4"
})(["background:", ";height:100%;min-height:0;overflow-y:auto;position:relative;border-radius:12px;box-shadow:0px 3px 6px rgba(0,0,0,0.12);.ant-space{box-shadow:none;border:none;}img{max-width:100%;}@media (max-width:", "px){display:none;}"], styleVariables.colors.gray1, styleVariables.breakpoints.sm);
var StyledSummaryColumn = styled(Col).withConfig({
  displayName: "pin-layoutcomponent__StyledSummaryColumn",
  componentId: "sc-c20uxq-5"
})(["padding-left:", " !important;height:100%;min-height:0;overflow-y:auto;&::-webkit-scrollbar{display:none;}"], getSize('padding12'));
/** Unpinned: wider question column, narrower section summary (col2 + col3 = 24). */

var COL_SPAN_GRID = {
  col1: 0,
  col2: 17,
  col3: 7,
  offsetLeft: 0
};
/** Pinned: balanced reading/passage, question, and section-summary columns. */

var COL_SPAN_PIN_GRID = {
  col1: 7,
  col2: 12,
  col3: 5,
  offsetLeft: 0
};
var countdownMobileHeight = 105;
export var PinLayout = function PinLayout(_ref2) {
  var renderPinColumn = _ref2.renderPinColumn,
      renderMainContentColumn = _ref2.renderMainContentColumn,
      renderSummaryColumn = _ref2.renderSummaryColumn,
      pinStatus = _ref2.pinStatus,
      setPinStatus = _ref2.setPinStatus,
      onClosePinnedItem = _ref2.onClosePinnedItem,
      pageHeaderHeight = _ref2.pageHeaderHeight,
      heightScreen = _ref2.heightScreen,
      _ref2$fillParent = _ref2.fillParent,
      fillParent = _ref2$fillParent === void 0 ? false : _ref2$fillParent;
  // Configs
  var deviceType = useDeviceType(); // Local states

  var _useState = useState(COL_SPAN_GRID),
      spanCols = _useState[0],
      setSpanCols = _useState[1];

  var _useState2 = useState(countdownMobileHeight),
      countdownMobileHeaderHeight = _useState2[0],
      setCountdownMobileHeaderHeight = _useState2[1]; // Callbacks


  var handleClosePinnedPanel = function handleClosePinnedPanel() {
    setSpanCols(COL_SPAN_GRID);
    setPinStatus(PinStatus.unpin);
    onClosePinnedItem();
  }; // Effects


  useEffect(function () {
    if (pinStatus === PinStatus.pinned) {
      setSpanCols(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), COL_SPAN_PIN_GRID);
      });
    }

    if (pinStatus === PinStatus.unpin) {
      setSpanCols(COL_SPAN_GRID);
    }
  }, [pinStatus]);
  useEffect(function () {
    if (deviceType === DeviceType.mobile) {
      onClosePinnedItem();
      setCountdownMobileHeaderHeight(countdownMobileHeight);
    } else {
      setCountdownMobileHeaderHeight(0);
    }
  }, [deviceType]);
  return /*#__PURE__*/_jsxs(Layout, {
    gutter: [24, 0],
    justify: "start",
    align: "stretch",
    $heightScreen: heightScreen,
    $pageHeaderHeight: pageHeaderHeight + countdownMobileHeaderHeight,
    $fillParent: fillParent,
    children: [/*#__PURE__*/_jsxs(StyledPinColWrapper, {
      "data-pin-panel": "true",
      md: {
        span: 0
      },
      lg: {
        span: spanCols.col1
      },
      children: [/*#__PURE__*/_jsx(StyledCloseButtonWrapper, {
        children: /*#__PURE__*/_jsx(StyledCloseIcon, {
          icon: /*#__PURE__*/_jsx(CloseOutlined, {}),
          onClick: handleClosePinnedPanel
        })
      }), renderPinColumn]
    }), /*#__PURE__*/_jsx(StyledSectionQuestionColumn, {
      "data-submission-questions-scroll": "",
      xs: {
        span: 24
      },
      lg: {
        span: spanCols.col2,
        offset: spanCols.offsetLeft
      },
      children: renderMainContentColumn
    }), deviceType === DeviceType.mobile ? null : /*#__PURE__*/_jsx(StyledSummaryColumn, {
      span: spanCols.col3,
      children: renderSummaryColumn
    })]
  });
};